export const consetPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_PinItPinWidget',
  componentNameDefault: 'Share from Pinterest',
  companyNameKey: 'CookieConsent_Dataset_Company_Pinterest',
  companyNameDefault: 'Pinterest',
};
